// extracted by mini-css-extract-plugin
export default {"wrap":"JuriScreen_wrap__sTcCJ","juri_container":"JuriScreen_juri_container__0OINx"};